<template>

		<div class="list--view">
            <div class="single--list-view single--list-view-Assettables">
                <vs-select
                    class="selectExample"
                    v-model="selectTypeAssettables"
                    @input="assetSelected"
                >
                    <vs-select-item
                        :is-selected="item.isSelected"
                        :key="index"
                        :value="item.value"
                        :text="item.label"
                        v-for="(item,index) in optionsTypeAssettables" />
                </vs-select>
            </div>
    
        </div>
</template>

<script>
    export default {
        data () {
            return {
                selectTypeAssettables: (location.search.indexOf("filterByModel") >= 0 ) 
                    ? (new URLSearchParams(location.search)).get("filterByModel")
                    : '',
                optionsTypeAssettables:[],
            } 
        },
        methods: {
            assetSelected(selectedOption, id) {
                if (selectedOption == "") {
                    location.href = "/asset-person-delivery";
                    
                } else {
                    location.href = app.__vue__.addParam("filterByModel", selectedOption);
                }
            },
         
            loadAssetes(){
                axios
                    .get("/get-assettables-filters")
                    .then(response => {
                       this.optionsTypeAssettables=response.data;
                    });
            },
        },
        mounted() {
            this.loadAssetes();
        }

    }
</script>
